export default "__VITE_PUBLIC_ASSET__3db35e3a__"